<div class="body">
  @if (datosUsuario) {
    <div class="container">
      <div class="row title-box mt-3">
        <div class="col-12 col-sm-12">
          <h3 class="txtbienvenida">Consultar <span class="txtbienvenida-2">auditoría</span></h3>
        </div>
      </div>
      <form class="custom-form" [formGroup]="consulAuditoriaForm">
        <div class="row justify-content-md-start mt-4">
          <div class="col-12 col-sm-6">
            <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateField('tipo_accion')}">
              <label for="tipo_accion" class="form-label">Tipo de acción</label>
              <select class="form-control" formControlName="tipo_accion"[ngClass]="{'is-invalid':validateField('tipo_accion')}" required >
                <option value="null">Seleccione una opción</option>
                <option value="CONSULTAS">CONSULTAS</option>
                <option value="MÓDULOS">MÓDULOS</option>
                <option value="PARAMETRIZACIÓN">PARAMETRIZACIÓN</option>
                <option value="TRANSACCIONES">TRANSACCIONES</option>
              </select>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-6">
            <div class="mb-3 form-label">
              <label for="idTipoDocIdentidad_NeoTipoDocIdentidad" class="form-label">Tipo de documento usuario</label>
              <select class="form-control" formControlName="idTipoDocIdentidad_NeoTipoDocIdentidad" (change)="validarSelect()">
                <option [value]="null">Seleccione una opción</option>
                @for (documento of documentos; track documento) {
                  <option [value]="documento.idTipoDocIdentidad">
                    {{ documento.nombre }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-label">
              <label for="numDoc" class="form-label">Número de documento usuario</label>
              <input type="text" class="form-control" minlength="5" maxlength="10" formControlName="numeroDocumento"
                #input (input)="input.value=$event.target.value.toUpperCase()" (keypress)="validateDocument($event)">
              </div>
            </div>
          </div>
          <div class="row justify-content-md-start mt-4">
            <div class="col-12 col-sm-6">
              <div class="mb-3 form-label">
                <label for="fechaInicio" class="form-label">Fecha inicial de acción</label>
                <input type="date" max="{{fechaActual}}" class="form-control" formControlName="fechaInicio">
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="mb-3 form-label">
                <label for="fechaFin" class="form-label">Fecha final de acción</label>
                <input type="date" max="{{fechaActual}}" class="form-control" formControlName="fechaFin">
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center mt-3 g-3">
            <div class="col-12 col-sm-3 container-btn">
              <button class="btn btn-primary hvr-shrink" [disabled]="!consulAuditoriaForm.valid" (click)="consultaAuditoria()" style="width: 180px;" type="submit">Consultar</button>
            </div>
            @if (datosTabla) {
              <div class="col-12 col-sm-3 container-btn"  >
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargar(true)" type="submit">Exportar a Excel</button>
              </div>
            }
            @if (datosTabla) {
              <div class="col-12 col-sm-3 container-btn"  >
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargar(false)" type="submit">Exportar a Txt</button>
              </div>
            }
            <div class="col-12 col-sm-3 container-btn">
              <button class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">Volver</button>
            </div>
          </div>
          @if (datosTabla) {
            <div class="row mt-4 pr-3 pl-3" >
              <div class="table-responsive">
                <table class="table table-striped table-borderless rounded">
                  <thead class="table_head">
                    <tr>
                      <th scope="col" class="no-styles table-header" id="tipoAccion">Tipo de Acción</th>
                      <th scope="col" class="no-styles table-header" id="nombreUsuario">Usuario realizó acción</th>
                      <th scope="col" class="no-styles table-header" id="numeroDocumento">Tipo y número Doc</th>
                      <th scope="col" class="no-styles table-header" id="fecha">Fecha en que se realizó acción</th>
                      <th scope="col" class="no-styles table-header" id="hora">Hora en que se realizó acción</th>
                      <th scope="col" class="no-styles table-header" id="equipo">Equipo desde donde se realizó acción</th>
                      <th scope="col" class="no-styles table-header" id="accion">Información complementaria</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (usuario of listaAuditoria; track usuario; let i = $index) {
                      <tr>
                        <th scope="row">{{usuario.tipoTransaccion}}</th>
                        <td>{{usuario.usuarioAccion}}</td>
                        <td>{{usuario.tipoYNumDoc}}</td>
                        <td>{{usuario.fechaAccion}}</td>
                        <td>{{usuario.hora}}</td>
                        <td>{{usuario.equipo}}</td>
                        <td>
                          <button id="btn-info" class="hvr-shrink" type="button" (click)="verDetalle(i)">
                            <i class="fas fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (datosTabla) {
            <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
            [totalPaginas]="totalPaginas"></app-pagination>
          }
          <a id="downloadFile" style="display: none;"></a>
        </form>
      </div>
    }

    @if (!datosUsuario) {
      <div class="container">
        <div class="row title-box mt-3">
          <div class="col-12 col-sm-12">
            <h3 class="txtbienvenida">Información específica de <span class="txtbienvenida-2">la acción de auditoría</span></h3>
          </div>
        </div>
        <form class="custom-form" [formGroup]="mostrarForm">
          <div class="row justify-content-md-center">
            <div class="col-12 ">
              <div class="mb-3 form-label">
                <label for="accion" class="form-label">Tipo de acción</label>
                <input disabled type="text" class="form-control" formControlName="accion">
              </div>
            </div>
          </div>
        </form>
        <div class="row mt-4 pr-3 pl-3">
          @if (detalleAuditoria != null) {
            <div class="table-responsive">
              <table class="table table-striped table-borderless rounded">
                <thead class="table_head">
                  <tr>
                    @if (detalleAuditoria.criteriosBusqueda) {
                      <th scope="col" class="no-styles table-header" id="critBusq">Criterios de busqueda</th>
                    }
                    @if (detalleAuditoria.estadoTransaccion) {
                      <th scope="col" class="no-styles table-header" id="estadoTransaccion">Estado transacción</th>
                    }
                    @if (detalleAuditoria.moduloEjecutado) {
                      <th scope="col" class="no-styles table-header" id="modEjec">Modulo ejecutado</th>
                    }
                    @if (detalleAuditoria.valorAnterior) {
                      <th scope="col" class="no-styles table-header" id="InfAnterior">Datos anteriores acción</th>
                    }
                    @if (detalleAuditoria.valorNuevo) {
                      <th scope="col" class="no-styles table-header" id="NuevaInf" >Nuevos datos acción</th>
                    }
                    @if (detalleAuditoria.tipoTransaccion) {
                      <th scope="col" class="no-styles table-header" id="tipoTransaccion" >Tipo transacción</th>
                    }
                    @if (detalleAuditoria.navegador) {
                      <th scope="col" class="no-styles table-header" id="navegador">Navegador</th>
                    }
                    @if (detalleAuditoria.sistemaOperativo) {
                      <th scope="col" class="no-styles table-header" id="sistemaOperativo">Sistema Operativo</th>
                    }
                    @if (detalleAuditoria.userAgent) {
                      <th scope="col" class="no-styles table-header" id="userAgent">userAgent</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    @if (detalleAuditoria.criteriosBusqueda) {
                      <th scope="row" >{{detalleAuditoria.criteriosBusqueda}}</th>
                    }
                    @if (detalleAuditoria.estadoTransaccion) {
                      <th scope="row" >{{detalleAuditoria.estadoTransaccion}}</th>
                    }
                    @if (detalleAuditoria.moduloEjecutado) {
                      <th scope="row" >{{detalleAuditoria.moduloEjecutado}}</th>
                    }
                    @if (detalleAuditoria.valorAnterior) {
                      <th scope="row" >{{detalleAuditoria.valorAnterior}}</th>
                    }
                    @if (detalleAuditoria.valorNuevo) {
                      <td scope="row">{{detalleAuditoria.valorNuevo}}</td>
                    }
                    @if (detalleAuditoria.tipoTransaccion) {
                      <td scope="row">{{detalleAuditoria.tipoTransaccion}}</td>
                    }
                    @if (detalleAuditoria.navegador) {
                      <th scope="row" >{{detalleAuditoria.navegador}}</th>
                    }
                    @if (detalleAuditoria.sistemaOperativo) {
                      <th scope="row" >{{detalleAuditoria.sistemaOperativo}}</th>
                    }
                    @if (detalleAuditoria.userAgent) {
                      <th scope="row" >{{detalleAuditoria.userAgent}}</th>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
        <div class="row justify-content-md-center mt-3">
          <div class="col-12 col-sm-3 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;" (click)="ngOnInit();consultaAuditoria()">Volver</button>
          </div>
        </div>
        <a id="downloadFile" style="display: none;"></a>
      </div>
    }

    <!-- Modal -->
    <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>No se encontraron resultados con los criterios ingresados</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade text-center" style="color: black;" id="mensajeNoSeEncontro" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>No se encontro Información complementaria</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
